import { motion, useReducedMotion } from "framer-motion";
import { Icon } from "./Icon";

export function PrimaryCta({
  children = "Check a vehicle",
  icon = true,
  as = "button",
  href,
  className = "",
  ...props
}) {
  const reduce = useReducedMotion();
  const classes = `inline-flex items-center justify-center gap-1.5 border-0 font-medium transition-all h-10 px-5 text-sm rounded-full bg-primary text-primary-foreground hover:opacity-90 cursor-pointer ${className}`;
  const motionProps = reduce
    ? {}
    : { whileHover: { scale: 1.03 }, whileTap: { scale: 0.97 }, transition: { type: "spring", stiffness: 420, damping: 24 } };

  if (as === "a" || href) {
    return (
      <motion.a href={href || "#"} className={classes} {...motionProps} {...props}>
        {children}
        {icon ? <Icon name="arrow-right" /> : null}
      </motion.a>
    );
  }

  return (
    <motion.button type="button" className={classes} {...motionProps} {...props}>
      {children}
      {icon ? <Icon name="arrow-right" /> : null}
    </motion.button>
  );
}

export function FadeIn({ children, className = "", delay = 0 }) {
  const reduce = useReducedMotion();
  if (reduce) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.35, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}
